import { render, staticRenderFns } from "./startBetting.vue?vue&type=template&id=04c236ad&scoped=true&lang=pug&"
import script from "./startBetting.vue?vue&type=script&lang=ts&"
export * from "./startBetting.vue?vue&type=script&lang=ts&"
import style0 from "./startBetting.vue?vue&type=style&index=0&id=04c236ad&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c236ad",
  null
  
)

export default component.exports